import { Container, DropdownMenu, DropdownItemProps } from '@my/ui'
import { SecondaryNavigation, SecondaryNavigationProps } from 'app/components'
import { useState } from 'react'

interface FreshersNavProps {}

const dropdownItems = [
  {
    label: 'Freshers',
    href: '/freshers',
  },
  {
    label: 'Discounts',
    href: '/student-discount',
  },
  {
    label: 'Chats',
    href: '/groups/feed',
  },
  {
    label: 'Life',
    href: '/life',
  },
]

export const FreshersNav = ({ ...props }: FreshersNavProps & SecondaryNavigationProps) => {
  const [dropdownMenuOpen, setDropdownMenuOpen] = useState(false)

  return (
    <SecondaryNavigation {...props}>
      <Container gap="$2" fd="row" ai="center" size="base" gutter>
        <DropdownMenu
          open={dropdownMenuOpen}
          onOpenChange={setDropdownMenuOpen}
          initialItem={dropdownItems[0] as DropdownItemProps}
          items={dropdownItems}
          itemProps={{
            h: 40,
          }}
          contentProps={{
            top: -40,
            $gtSm: {
              display: 'none',
            },
          }}
          triggerProps={{
            h: 40,
            mr: '$2',
            $gtSm: {
              display: 'none',
            },
          }}
        />
      </Container>
    </SecondaryNavigation>
  )
}
